var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ReportListPage"},[_c('DashboardSectionHeader',{attrs:{"title":"Reports"}}),_c('DashboardList',{attrs:{"columns":['Report']}},_vm._l((_vm.reports),function(report){return _c('DashboardListItem',{key:report.type,attrs:{"columns":[report.title],"actions":[{
                label: 'View',
                click: function () { return _vm.$router.push(("/company/reports/view?type=" + (report.type))); }
            }]}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }